"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = void 0;
const react_1 = __importDefault(require("react"));
const merlin_email_input_1 = require("@travelnest/merlin.email-input");
const theme_1 = __importDefault(require("../../styles/theme"));
const styled_1 = __importDefault(require("@emotion/styled"));
// TODO: This should ported back into the EmailInput
const StyledEmailInputWrapper = styled_1.default.div `
	input {
		border-radius: ${theme_1.default.layout.radius.squared} !important;
		border-color: ${theme_1.default.colours.neutral.light} !important;
		transition: border-color ${theme_1.default.motion.transition.default};
		color: ${theme_1.default.colours.text.darker} !important;
		${({ valid }) => !valid && `
			border-color: ${theme_1.default.colours.error.default} !important;
			color: ${theme_1.default.colours.error.default} !important;
			background-color: ${theme_1.default.colours.error.tint} !important;
		`};

		font-size: ${theme_1.default.typography.c3.fontSize} !important;
		line-height: ${theme_1.default.typography.c3.lineHeight} !important;
		font-weight: ${theme_1.default.typography.c3.fontWeight} !important;

		&:hover,&:active,&:focus {
			border-color: ${theme_1.default.colours.neutral.dark} !important;
			${({ valid }) => !valid && `
			border-color: ${theme_1.default.colours.error.default};
			color: ${theme_1.default.colours.error.default};
			background-color: ${theme_1.default.colours.error.tint};
		`};
		}

		-webkit-appearance: none;
	}

	> div:first-of-type::after {
		border-radius: calc(${theme_1.default.layout.radius.squared} + 1px);
	}
`;
const EmailInput = (props) => {
    return react_1.default.createElement(StyledEmailInputWrapper, { valid: props.invalid !== undefined ? !props.invalid : false },
        react_1.default.createElement(merlin_email_input_1.EmailInput, Object.assign({}, props)));
};
exports.EmailInput = EmailInput;
//# sourceMappingURL=EmailInput.js.map